<template>
  <div
    class="popover-page-render-wrap"
    :style="{
      width: `${width}px`,
    }"
  >
    <PageRender
      v-if="activeDetailData.currentPageConfig"
      :active-detail-data="activeDetailData"
      :is-mobile="true"
      :is-page="false"
    />
    <div v-else class="popover-page-render-empty">
      暂无浮框内容
    </div>
  </div>
</template>

<script setup>
import { inject, provide, reactive, watch } from "vue";
import PageRender from "@/components/render/PageRender.vue";
import { makeAllArcListMap } from "@/utils/asyncData.js";

const props = defineProps({
  areaData: {
    type: String,
    default: "",
  },
  width: {
    type: Number,
    default: 400,
  },
});

const activeDetailData = reactive({
  currentPageConfig: null,
  pages: [],
  allArcListMap: {},
});

const parentGetConfigJson = inject("getConfigJson", () => ({}));
const parentGetCommonConfigJson = inject("getCommonConfigJson", () => ({}));

function getPopoverConfigJson() {
  const parentConfig =
    typeof parentGetConfigJson === "function" ? parentGetConfigJson() : {};
  const currentPageConfig = activeDetailData.currentPageConfig || {};

  return {
    ...currentPageConfig,
    langJson: {
      ...(parentConfig?.langJson || {}),
      ...(currentPageConfig?.langJson || {}),
    },
    bindData: {
      ...(parentConfig?.bindData || {}),
      ...(currentPageConfig?.bindData || {}),
    },
  };
}

provide("getConfigJson", getPopoverConfigJson);
provide("getCommonConfigJson", parentGetCommonConfigJson);

async function buildActiveDetailData(areaDataStr = "") {
  if (!areaDataStr) {
    activeDetailData.currentPageConfig = null;
    activeDetailData.pages = [];
    activeDetailData.allArcListMap = {};
    return;
  }

  const parsedPages = JSON.parse(areaDataStr);
  const { $customFetch } = useNuxtApp();
  const resMakeData = await makeAllArcListMap(
    $customFetch,
    {},
    {
      dataList: [
        {
          areaData: areaDataStr,
        },
      ],
    },
    {},
    parsedPages
  );

  activeDetailData.currentPageConfig =
    (resMakeData.pages && resMakeData.pages[0]) || null;
  activeDetailData.pages = resMakeData.pages || [];
  activeDetailData.allArcListMap = resMakeData.allArcListMap || {};
}

watch(
  () => props.areaData,
  (value) => {
    buildActiveDetailData(value).catch((error) => {
      console.error("build popover page render data error", error);
      activeDetailData.currentPageConfig = null;
      activeDetailData.pages = [];
      activeDetailData.allArcListMap = {};
    });
  },
  { immediate: true }
);
</script>

<style scoped>
.popover-page-render-wrap {
  max-width: 100%;
  overflow: auto;
  max-height: 80vh;
}

.popover-page-render-empty {
  color: #999;
  font-size: 14px;
  padding: 20px;
  text-align: center;
}
</style>
